import React from "react";
import {Breadcrumb, Layout, Menu, Typography} from "antd";
import { UserOutlined, LaptopOutlined, NotificationOutlined } from '@ant-design/icons';
import {getHostAddress,getFrontEndAddress} from "../../Tool/UtileFun"
import cookie from "react-cookies";
import robotLogo from "../../User/IMG/robotLogo.png";
import backgroundImg from "../../User/IMG/mainBackground.png";
import {AdminInfoCar} from "./AdminInfoCar";

export function AdminInfo(){

    const { SubMenu } = Menu;
    const { Header, Content, Sider } = Layout;
    const { Text, Link } = Typography;
    const classPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/class"
    }
    const studentPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/student"
    }
    const taskPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/task"
    }
    const teacherPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/teacher"
    }
    const adminPage = () =>{
        window.location.href="http://"+getFrontEndAddress()+"/admin/adminInfo"
    }
    const outLogin = () =>{
        const username = "username"
        const classId = "classID"
        const role = "role"
        const userId = "userId"
        const roleTest = "admin"
        cookie.remove(userId)
        cookie.remove(username)
        cookie.remove(role)
        cookie.remove(classId)
        cookie.remove(roleTest)
        window.location.href="http://"+getFrontEndAddress()+"/admin/login"
    }
    const layout = (
        <Layout>
            <Header className="header">
                <div className="logo" />
                {/*<Menu theme="dark" mode="horizontal" defaultSelectedKeys={['1']}>*/}
                {/*    <Menu.Item key="1">后台管理</Menu.Item>*/}
                {/*    /!*<Menu.Item key="2">nav 2</Menu.Item>*/}
                {/*    <Menu.Item key="3">nav 3</Menu.Item>*!/*/}
                {/*</Menu>*/}
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    backgroundImage: `url(${robotLogo})`,
                    backgroundSize:"100% 100%",
                    color:"white"
                }}>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                </div>
                <div style={{
                    //zIndex: 99999,
                    position: "absolute",
                    color:"white",
                    fontSize:"30px",
                    margin:"0 0 0 530px",
                    fontFamily: "STKaiti"
                }}>RPA审计机器人课程平台</div>
            </Header>
            <Layout>
                <Sider width={200} className="site-layout-background">
                    <Menu
                        mode="inline"
                        defaultSelectedKeys={['5']}
                        defaultOpenKeys={['sub1','sub3']}
                        style={{ height: '100%', borderRight: 0 }}
                    >
                        <SubMenu key="sub1" icon={<UserOutlined />} title="基础管理">
                            <Menu.Item key="1" onClick={classPage}>班级管理</Menu.Item>
                            <Menu.Item key="2" onClick={studentPage}>学生管理</Menu.Item>
                            <Menu.Item key="3" onClick={teacherPage}>教师管理</Menu.Item>
                        </SubMenu>
                        {/*<SubMenu key="sub2" icon={<UserOutlined />} title="作业管理">*/}
                        {/*    <Menu.Item key="3" onClick={taskPage}>作业批改</Menu.Item>*/}
                        {/*</SubMenu>*/}
                        <SubMenu key="sub3" icon={<UserOutlined />} title="账号管理">
                            <Menu.Item key="5" onClick={adminPage}>个人信息</Menu.Item>
                            <Menu.Item key="4" onClick={outLogin}><Text type="danger">退出</Text></Menu.Item>
                        </SubMenu>
                    </Menu>
                </Sider>
                <Layout style={{
                    padding: '0 24px 24px',
                    backgroundImage: `url(${backgroundImg})`,
                    backgroundSize:"100% 100%"
                }}>
                    <Breadcrumb style={{ margin: '16px 0' }}>
                        {/*<Breadcrumb.Item>Home</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>List</Breadcrumb.Item>*/}
                        {/*<Breadcrumb.Item>App</Breadcrumb.Item>*/}
                    </Breadcrumb>
                    <Content
                        className="site-layout-background"
                        style={{
                            //overflow: 'initial',
                            minHeight: document.body.clientHeight
                        }}
                        // style={{
                        //     marginTop: 17,
                        //     padding: 24,
                        //     //minHeight: "100%",
                        //     height: 615,
                        // }}
                    >
                        <AdminInfoCar></AdminInfoCar>
                    </Content>
                </Layout>
            </Layout>
        </Layout>
    )

    return(
        layout
    )
}
